/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Load_Failed1Inputs */

const vi_cmspage_load_failed1 = /** @type {(inputs: Cmspage_Load_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách trang. Tải lại trang để thử lại.`)
};

/**

* @param {Cmspage_Load_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_load_failed1 = /** @type {((inputs?: Cmspage_Load_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Load_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_load_failed1(inputs)
});
export { cmspage_load_failed1 as "cmsPage_load_failed" }